import * as React from "react"
import Svg, { Path } from "react-native-svg"

const DDCircle = ({ fill = "#2ad2c5", preserveAspectRatio ="xMidYMid slice", ...props}) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Capa 2"
    preserveAspectRatio={preserveAspectRatio}
    viewBox="0 0 607.64 607.64"
    {...props}
  >
    <Path
      d="M303.82 607.64c-40.99 0-80.78-8.04-118.28-23.9-36.19-15.31-68.67-37.2-96.55-65.09-27.88-27.88-49.78-60.37-65.09-96.55C8.04 384.6 0 344.81 0 303.82s8.04-80.78 23.9-118.28c15.31-36.19 37.2-68.67 65.09-96.55 27.88-27.88 60.37-49.78 96.55-65.09C223.03 8.04 262.83 0 303.82 0S384.6 8.04 422.1 23.9c36.19 15.31 68.67 37.2 96.55 65.09 27.88 27.88 49.78 60.37 65.09 96.55 15.86 37.49 23.9 77.29 23.9 118.28s-8.04 80.78-23.9 118.28c-15.31 36.19-37.2 68.67-65.09 96.55-27.88 27.88-60.37 49.78-96.55 65.09-37.49 15.86-77.29 23.9-118.28 23.9Zm2.61-490.96c-105.26-1.44-191.19 84.49-189.75 189.75 1.38 100.95 83.58 183.15 184.53 184.53 105.26 1.44 191.19-84.49 189.75-189.75-1.38-100.95-83.58-183.15-184.53-184.53Zm81.06 187.14c0-46.21-37.46-83.67-83.67-83.67s-83.67 37.46-83.67 83.67 37.46 83.67 83.67 83.67 83.67-37.46 83.67-83.67Z"
      data-name="Capa 1"
      style={{
        fill,
      }}
    />
  </Svg>
)
export default DDCircle
